import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import {environmentLoader} from './environments/environmentLoader';

environmentLoader.then(env => {

  Object.assign(environment, env);

  if (getEnvName() !== 'unknown') {
    enableProdMode();
  }

  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
});

import { AppModule } from './app/app.module';
import 'hammerjs';
// Swiper est distribué en web components : `register()` déclare <swiper-container>
// et <swiper-slide> auprès du navigateur, une seule fois au démarrage.
import { register as registerSwiperElements } from 'swiper/element/bundle';

registerSwiperElements();

import '@angular/compiler';

function getEnvName(): string {
  switch (window.location.hostname){
    case 'cnl.qualitel.delivery.trsb.net':
      return 'delivery';
    case 'cnl.recette.qualitel.org':
      return 'recette';
    case 'clea-preprod.qualitel.org/':
      return 'preprod';
    case 'clea.qualitel.org':
      return 'prod';
    default:
      return 'unknown';
  }
}
